import { render, staticRenderFns } from "./TWCityTown.vue?vue&type=template&id=56a2f124&"
import script from "./TWCityTown.vue?vue&type=script&lang=js&"
export * from "./TWCityTown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports